const RootController = require("./common/RootController");
const ResourcesModel = require("./common/ResourcesModel");
const Utils = require("./common/Utils");
const ClientConfiguration = require("./client_config/ClientConfiguration");

window.CudaLaunch = window.CudaLaunch || {};
$.extend(window.CudaLaunch, {
    models : {},
    controllers : {},
    clientConfiguration : new ClientConfiguration()
});

function CudaLaunchCommon(type) {
    window.App = (function() {
        let currentHostname = localStorage["CUDA.SSLVPN.hostname"];
        const appType = type || "SSLVPN";

        function isSSLVPNApp() {
            return appType === "SSLVPN";
        }

        function getApiRoot() {
            if (isSSLVPNApp()) {
                return "/sslvpn_api/";
            }
            return "/totp_api/";
        }

        function getHostname() {
            return currentHostname;
        }

        function setHostname(hostname) {
            currentHostname = (hostname === undefined) ? "" : hostname;

            if (currentHostname !== getDemoHostname()) {
                localStorage["CUDA.SSLVPN.hostname"] = currentHostname;
            }
        }

        function getRemoteUrlPrefix() {
            return (currentHostname === undefined) ? "" : "https://" + currentHostname;
        }

        function getDemoHostname() {
            return "cw-demo.barracuda.eu";
        }

        return {
            isSSLVPNApp : isSSLVPNApp,
            getApiRoot : getApiRoot,
            getHostname : getHostname,
            setHostname : setHostname,
            getRemoteUrlPrefix : getRemoteUrlPrefix,
            getDemoHostname : getDemoHostname
        };
    }());

    $(document).on("appinit", function() {
        // Set up i18n localisation
        $(document).on("pagebeforecreate", function(e) {
            $(e.target).i18n();
        });
    });

    $(document).on("appmodulesloaded", function() {
        // Sort out UI loading spinner on ajax calls
        const _ajax = $.ajax;
        let requests = 0;
        function handleAjax(options) {
            // Don't show the loading spinner for file uploads -- progress is displayed
            // in the file transfer manager dialog
            if (/^\/sslvpn_api\/vfs\/upload$/.test(options.url)) {
                return _ajax(options);
            }

            requests++;
            Utils.showLoading(true);

            return _ajax(options).always(function() {
                if (--requests == 0) {
                    Utils.showLoading(false);
                }
            });
        }

        $.extend({
            ajax : handleAjax
        });
    });

    $(document).on("frameworkready", function() {
        CudaLaunch.clientConfiguration.init().then(function() {
            //  Set up correct language using the client
            $.i18n.init({
                ns : {namespaces : ["common"]},
                resGetPath : "i18n/{lng}/{ns}.json",
                fallbackLng : "en",
                lng : CudaLaunch.clientConfiguration.getLanguage(),
                useCookie : false,
                nsseparator : "::",
                keyseparator : ":",
                getAsync : false,
                interpolationPrefix : "{",
                interpolationSuffix : "}",
                useDataAttrOptions : true
            });

            // Intended for page content to be added menus/navigation etc.
            $.event.trigger("appinit", []);

            // Intended for modules to be loaded (i.e. resources, firewall rules etc.)
            $.event.trigger("loadappmodules", []);

            // Add session token to POST/PUT/DELETE requests
            $.ajaxPrefilter(function(options) {
                if (CudaLaunch.serverConfiguration) {
                    const session = CudaLaunch.serverConfiguration.getSession();

                    if (session && (options.type.toUpperCase() === "POST" || options.type.toUpperCase() === "PUT" || options.type.toUpperCase() === "DELETE")) {
                        let sessionKey = session.key;
                        let sessionToken = session.token;

                        if (options.url.startsWith("/totp_api/")) {
                            sessionKey = session.totpKey;
                            sessionToken = session.totpToken;
                        }

                        if (options.data) {
                            // Depending on the browser/plugin etc. this could be a FormData object rather than a string
                            if (options.data.append) {
                                options.data.append(sessionKey, sessionToken);
                            } else {
                                options.data += "&" + sessionKey + "=" + sessionToken;
                            }
                        } else if (sessionKey !== undefined) {
                            options.data = sessionKey + "=" + sessionToken;
                        }
                    }
                }
            });

            // Event indicating that all the modules have now been loaded
            $.event.trigger("appmodulesloaded", []);

            // Trigger jQuery Mobile initialization that we postponed from earlier
            $.mobile.initializePage();

            // This can throw in jQuery 3.4.1, there's nothing we can do and we want the remaining code to execute, so log an error and carry on
            try {
                $.event.trigger("restorestate", []);
            } catch (e) {
                console.error("restorestate threw error");
            }

            // Event indicating that everything in the app is loaded and ready to go
            $.event.trigger("appready", []);

            document.addEventListener("resume", function() {
                $.event.trigger("appresumed", []);
            }, false);
        });
    });

    // Prevent scrolling of listviews etc. when popups are active
    $(document).on("popupafteropen", '[data-role="popup"]', function() {
        $("#mobileResources .ui-content").css("overflow", "hidden").on("touchmove.popup", function(e) {
            e.preventDefault();
        });
    }).on("popupafterclose", '[data-role="popup"]', function() {
        $("#mobileResources .ui-content").css("overflow", "auto").off("touchmove.popup");
    });
}

module.exports = CudaLaunchCommon;